import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { TextField, Button, Container, Alert, Snackbar, Box, Typography, Link, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/xpdlogo.png';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import toast from 'react-hot-toast'; // Make sure to import this

// import { useState } from 'react';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    // Add this state for password visibility
    const [showPassword, setShowPassword] = useState(false);
    const [showTwoFactorAuth, setShowTwoFactorAuth] = useState(false);
    const [twoFactorCode, setTwoFactorCode] = useState('');
    const [tempToken, setTempToken] = useState('');

    // Add this handler
    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    useEffect(() => {
        const checkToken = Cookies.get('token');
        const role = Cookies.get('role');

        const checkLogin = async () => {
            if (checkToken && role === 'admin') {
                navigate('/admin/dashboard');
            } else if (checkToken && role === 'user') {
                navigate('/dashboard');
            }
        };

        checkLogin();
    }, [navigate]);

    const apiKey = 'qU5HBiefzpNnkR9OYLj1InM3QYmkrqIHaLMnQ32KaXTZqctoluosFK83Hx2ZHbMk';

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/login', { username, password, apiKey });
            if (response.data.requires2FA) {
                // Show 2FA input
                setTempToken(response.data.tempToken);
                setShowTwoFactorAuth(true);
                return;
            }
            handleLoginSuccess(response.data);

            // sessionStorage.setItem('token', response.data.token);
            // sessionStorage.setItem('role', response.data.role);
            // sessionStorage.setItem('title', response.data.title);
            // sessionStorage.setItem('email', response.data.email);
            // sessionStorage.setItem('userStatus', response.data.status);
            // sessionStorage.setItem('kycStatus', response.data.kycStatus);

            // setOpen(true);
            // toast.success('Login successful');
            // setMessage('Login successful');

            // if (response.data.role === 'admin') {
            //     navigate('/admin/dashboard');
            // } else if (response.data.role === 'user') {
            //     navigate('/dashboard');
            // } else {
            //     // remove token
            //     sessionStorage.removeItem('token');
            //     sessionStorage.removeItem('role');
            //     navigate('/login');
            // }
        } catch (error) {
            setOpen(true);
            toast.error('Login failed');
            // setMessage('Login failed');
        }
    };
    const handleTwoFactorSubmit = async () => {
        try {
            const response = await axios.post('/api/verify-login-2fa', {
                token: Cookies.get('token'), // This is where the token is sent
                code: twoFactorCode,    // This is where the code is sent
                tempToken: tempToken    // This is where the tempToken is sent
            });

            if (response.data.success) {
                handleLoginSuccess(response.data);
            }
        } catch (error) {
            toast.error('Invalid 2FA code'); 
        }
    };
    const handleLoginSuccess = (data) => {
        const { token, role, user } = data;

        Cookies.set('token', token, { secure: true, sameSite: 'Strict' });
        Cookies.set('role', role, { secure: true, sameSite: 'Strict' });
        Cookies.set('title', data.title, { secure: true, sameSite: 'Strict' });
        Cookies.set('email', data.email, { secure: true, sameSite: 'Strict' });
        Cookies.set('userStatus', data.status, { secure: true, sameSite: 'Strict' });
        Cookies.set('kycStatus', data.kycStatus, { secure: true, sameSite: 'Strict' });
        Cookies.set('user', JSON.stringify(user), { secure: true, sameSite: 'Strict' });

        // Set auth header for future requests
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        setOpen(true);
        toast.success('Login successful');
        setMessage('Login successful');

        if (data.role === 'admin') {
            navigate('/admin/dashboard');
        } else if (data.role === 'user') {
            navigate('/dashboard');
        } else {
            Cookies.remove('token');
            Cookies.remove('role');
            navigate('/login');
        }
    };

    return (
        <div>
            <Container maxWidth="sm">
                <Box
                    sx={{
                        mt: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minHeight: '100vh',
                    }}
                >
                    <Paper
                        elevation={2}
                        sx={{
                            p: 3,
                            width: '100%',
                            maxWidth: '400px',
                            borderRadius: '12px',
                            mb: 4,
                            bgcolor: '#ffffff',
                        }}
                    >
                        {/* Logo */}
                        <Box sx={{ textAlign: 'center' }}>
                            <img
                                src={logo}
                                alt="XPD Logo"
                                style={{
                                    width: 'auto',
                                    height: '60px',
                                    marginBottom: '24px'
                                }}
                            />
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#000000',
                                    mb: 2,
                                }}
                            >
                                To access your account please enter your email and password.
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#666666',
                                    mb: 4
                                }}
                            >
                                If you are having problems signing in please click "Forgot password?" and follow the instructions.
                            </Typography>
                        </Box>

                        {/* Form */}
                        <form onSubmit={handleSubmit}>
                            <Box sx={{ mb: 2 }}>
                                <TextField
                                    label="Username"
                                    variant="outlined"
                                    fullWidth
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    size="small"
                                    type="email"
                                    autoComplete="email"
                                    inputProps={{
                                        inputMode: 'email'
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#000000',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#666666',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#000000',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#666666',
                                        },
                                    }}
                                />
                            </Box>

                            <Box sx={{ mb: 2 }}>
                                <TextField
                                    label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    variant="outlined"
                                    fullWidth
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    size="small"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleTogglePassword}
                                                    edge="end"
                                                    size="small"
                                                    sx={{
                                                        color: '#666666',
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                        },
                                                    }}
                                                >
                                                    {showPassword ? (
                                                        <VisibilityOff fontSize="small" />
                                                    ) : (
                                                        <Visibility fontSize="small" />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#000000',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#666666',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#000000',
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: '#666666',
                                        },
                                        // Add these styles to remove browser's default eye icon
                                        '& input::-ms-reveal': {
                                            display: 'none',
                                        },
                                        '& input::-ms-clear': {
                                            display: 'none',
                                        },
                                        '& input[type="password"]::-webkit-contacts-auto-fill-button': {
                                            display: 'none !important',
                                        },
                                        '& input[type="password"]::-webkit-credentials-auto-fill-button': {
                                            display: 'none !important',
                                            visibility: 'hidden',
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                        },
                                    }}
                                />

                            </Box>

                            {/* Forgot Password Link */}
                            <Box sx={{ mb: 2, textAlign: 'right' }}>
                                <Link
                                    href="/forgot-password"
                                    sx={{
                                        color: '#6d269b', // Changed color to purple
                                        textDecoration: 'none',
                                        '&:hover': {
                                            color: '#000000',
                                            textDecoration: 'underline'
                                        },
                                        fontSize: '0.875rem'
                                    }}
                                >
                                    Forgot password?
                                </Link>
                            </Box>

                            {/* Add Not Registered Section */}


                            {/* Add the 2FA section here */}
                            {showTwoFactorAuth ? (
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="h6" sx={{ mb: 2 }}>
                                        Two-Factor Authentication Required
                                    </Typography>
                                    <TextField
                                        label="Enter 2FA Code"
                                        variant="outlined"
                                        fullWidth
                                        value={twoFactorCode}
                                        onChange={(e) => setTwoFactorCode(e.target.value)}
                                        sx={{ mb: 2 }}
                                    />
                                    <Button
                                        onClick={handleTwoFactorSubmit}
                                        variant="contained"
                                        fullWidth
                                        sx={{
                                            bgcolor: '#000000',
                                            '&:hover': {
                                                bgcolor: '#333333',
                                            },
                                        }}
                                    >
                                        Verify
                                    </Button>
                                </Box>
                            ) : (
                                /* Existing sign in button */
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    size="medium"
                                    sx={{
                                        py: 1,
                                        bgcolor: '#000000',
                                        color: '#ffffff',
                                        '&:hover': {
                                            bgcolor: '#333333',
                                        },
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    Sign In
                                </Button>
                            )}


                            <Box sx={{ mt: 2, textAlign: 'center' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#666666',
                                        display: 'inline',
                                        mr: 1
                                    }}
                                >
                                    Not registered yet?
                                </Typography>
                                <Link
                                    href="/register"
                                    sx={{
                                        color: '#6d269b',
                                        textDecoration: 'none',
                                        fontWeight: 500,
                                        '&:hover': {
                                            color: '#000000',
                                            textDecoration: 'underline'
                                        }
                                    }}
                                >
                                    Create an account
                                </Link>
                            </Box>
                        </form>

                        {/* Footer Links */}
                        <Box sx={{
                            mt: 4,
                            pt: 3,
                            borderTop: '1px solid #e0e0e0',
                            textAlign: 'center'
                        }}>
                            <Box sx={{ mb: 1 }}>
                                <Link
                                    href="https://myxpd.app/terms-of-use"
                                    sx={{
                                        color: '#6d269b', // Changed color to purple
                                        textDecoration: 'none',
                                        mx: 1,
                                        fontSize: '0.8rem',
                                        '&:hover': { color: '#000000' }
                                    }}
                                >
                                    Terms & Conditions
                                </Link>
                                <Link
                                    href="https://myxpd.app/privacy-policy"
                                    sx={{
                                        color: '#6d269b', // Changed color to purple
                                        textDecoration: 'none',
                                        mx: 1,
                                        fontSize: '0.8rem',
                                        '&:hover': { color: '#000000' }
                                    }}
                                >
                                    Privacy
                                </Link>
                                <Link
                                    href="https://myxpd.app/cookies"
                                    sx={{
                                        color: '#6d269b', // Changed color to purple
                                        textDecoration: 'none',
                                        mx: 1,
                                        fontSize: '0.8rem',
                                        '&:hover': { color: '#000000' }
                                    }}
                                >
                                    Cookies
                                </Link>
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#6d269b', // Changed color to purple
                                    fontSize: '0.8rem'
                                }}
                            >
                                © 2024-2025 XPD. All Rights Reserved.
                            </Typography>
                        </Box>
                    </Paper>
                </Box>
            </Container>


            <Snackbar open={open} autoHideDuration={1200} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                slots={{ transaition: 'slide' }}
            >
                <Alert

                    onClose={handleClose}
                    severity={message === 'Login successful' ? 'success' : 'error'}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Login;